<template>
  <v-col cols="12">
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step step="1">
          <span class="subtitle-2">Group</span>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2">
          <span class="subtitle-2">Hierarchy</span>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">
          <span class="subtitle-2">Properties</span>
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items style="height: calc(100vh - 180px)">
        <v-stepper-content step="1" class="fill-height custom-stepper">
          <v-card width="100%" height="100%">
            <v-form ref="groupForm" class="mt-2">
              <v-text-field
                label="Name"
                dense
                outlined
                v-model="form.name"
              ></v-text-field>
              <v-textarea
                rows="3"
                label="Description"
                v-model="form.description"
                dense
                outlined
              ></v-textarea>
            </v-form>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2" class="fill-height custom-stepper">
          <v-card width="100%" height="100%">
            <v-row no-gutters class="fill-height">
              <v-col
                cols="2"
                class="fill-height"
                style="border-right: 1px solid lightgrey"
              >
                <v-list dense class="ma-0 pa-0">
                  <v-subheader class="subtitle-1">Hierarchies</v-subheader>
                  <v-divider></v-divider>
                  <v-list-item-group v-model="selectedHierarchy">
                    <v-list-item
                      v-for="(item, idx) in hierarchies"
                      :key="idx"
                      :value="item.id"
                    >
                      <span class="subtitle-2">{{ item.name }}</span>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols="10">
                <v-row no-gutters class="pa-2 fill-height">
                  <organogram
                    ref="organogram"
                    :structure="structure"
                    mode="select"
                  />
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3" class="fill-height custom-stepper">
          <v-card width="100%" height="100%">
            <v-row no-gutters class="fill-height">
              <v-col cols="6" class="fill-height pa-1">
                <v-card color="grey lighten-1">
                  <v-row no-gutters class="py-1 px-2">
                    <span class="subtitle-1">Available</span>
                  </v-row>

                  <v-divider></v-divider>

                  <v-row
                    no-gutters
                    style="height: calc(100vh - 261px); overflow: auto"
                  >
                    <v-col
                      cols="12"
                      v-for="(filter, idx) in availableFilters"
                      :key="idx"
                    >
                      <span class="subtitle-1">
                        <b>{{ filter.name }}</b>
                      </span>
                      <v-row
                        v-for="(value, index) in filter.values"
                        @click="selectValue(value)"
                        :key="index"
                        no-gutters
                        align="center"
                        class="pa-1 ml-5 mr-2 custom-list-item"
                      >
                        <span class="caption">{{ value.value }}</span>
                        <v-spacer></v-spacer>
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="6" class="fill-height pa-1">
                <v-card color="grey lighten-1">
                  <v-row no-gutters class="py-1 px-2">
                    <span class="subtitle-1">Selected</span>
                  </v-row>

                  <v-row
                    no-gutters
                    style="height: calc(100vh - 261px); overflow: auto"
                  >
                    <v-col
                      cols="12"
                      v-for="(filter, idx) in selectedFilters"
                      :key="idx"
                    >
                      <span class="subtitle-1">
                        <b>{{ filter.name }}</b>
                      </span>
                      <v-row
                        v-for="(value, index) in filter.values"
                        @click="deSelectValue(value)"
                        :key="index"
                        no-gutters
                        align="center"
                        class="pa-1 ml-5 mr-2 custom-list-item"
                      >
                        <span class="caption">
                          {{ value.value }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>

      <v-row no-gutters class="pa-1">
        <v-btn
          color="primary"
          @click="step--"
          :disabled="step == 1"
          class="mr-2"
        >
          Prev
        </v-btn>
        <v-btn color="error" @click="$router.push(`/Group`)"> Cancel </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="save" v-if="step == 3"> Save </v-btn>
        <v-btn color="primary" @click="step++" v-else> Next </v-btn>
      </v-row>
    </v-stepper>
  </v-col>
</template>

<script>
import organogram from "@/components/Organogram/organogram";

export default {
  components: {
    organogram,
  },
  data() {
    return {
      edit: false,
      step: 1,
      form: {
        name: null,
        description: null,
        filters: [],
      },
      structure: [],
      hierarchies: [],
      providerFilters: [],
      selectedHierarchy: null,
    };
  },
  watch: {
    selectedHierarchy(val) {
      let self = this;

      if (val != null) {
        self.fetchStructure();
      }
    },
  },
  computed: {
    selectedFilterValues() {
      return this.$store.getters.getSelectedFilters;
    },
    availableFilters() {
      let self = this;

      let selectedIds = self.selectedFilterValues.map((item) => {
        return item.id;
      });

      let retVal = [];

      self.providerFilters.forEach((el) => {
        let obj = Object.assign({}, el);

        var values = obj.values.filter((value) => {
          return !selectedIds.includes(value.id);
        });

        obj.values = values;

        retVal.push(obj);
      });

      return retVal;
    },
    selectedFilters() {
      let self = this;
      let retVal = [];

      let filterIds = self.selectedFilterValues.map((item) => {
        return item.providerFilterId;
      });

      var providerFilters = self.providerFilters.filter((el) => {
        if (filterIds.includes(el.id)) {
          return el;
        }
      });

      providerFilters.forEach((element) => {
        let obj = Object.assign({}, element);

        obj.values = self.selectedFilterValues.filter((el) => {
          return el.providerFilterId == obj.id;
        });

        retVal.push(obj);
      });

      return retVal;
    },
  },
  mounted() {
    let self = this;

    this.fetchHierarchies();
    this.fetchProviderFilters();

    if (this.$route.params.id > 0) {
      self.edit = true;
      self.fetchData();
    }
  },
  beforeDestroy() {
    this.$store.commit("clearSelectedFilters");
    this.$store.commit("clearSelectedFilterIds");
  },
  methods: {
    fetchData() {
      let self = this;

      self.get(`Group/GetWithFilters?id=${self.$route.params.id}`).then((r) => {
        if (r.data.success) {
          self.form = r.data.data;

          self.form.filters.forEach((element) => {
            self.$store.commit(`pushFilter`, element.providerFilterValue);
          });
        }
      });
    },
    fetchHierarchies() {
      let self = this;

      self.get(`Hierarchy/GetAll`).then((r) => {
        if (r.data.success) {
          self.hierarchies = r.data.data;
        }
      });
    },
    fetchProviderFilters() {
      let self = this;

      self.get(`DataProvider/GetFiltersWithValues`).then((r) => {
        if (r.data.success) {
          self.providerFilters = r.data.data;
        }
      });
    },
    fetchStructure() {
      let self = this;

      self
        .get(`Hierarchy/GetStructure?id=${self.selectedHierarchy}`)
        .then((r) => {
          if (r.data.success) {
            self.structure = r.data.data;
          }
        });
    },
    selectValue(value) {
      let self = this;

      self.$store.commit("pushFilter", value);
      //self.selectedFilterValues.push(value);
    },
    deSelectValue(value) {
      let self = this;

      self.$store.commit("removeFilter", value);
    },
    save() {
      let self = this;
      let method = "post";
      let url = "Group";

      let id = self.$route.params.id;

      self.selectedFilterValues.forEach((element) => {
        self.form.filters.push({
          groupId: id == -1 ? 0 : id,
          providerFilterValueId: element.id,
        });
      });

      if (self.edit) {
        method = "put";
        url += `?id=${id}`;
      }

      self[method](url, self.form).then((r) => {
        if (r.data.success) {
          self.$router.push(`/Group`);
        }
      });
    },
  },
};
</script>

<style>
.custom-stepper .v-stepper__wrapper {
  height: 100%;
}

.custom-list-item {
  border-top: 1px solid;
  border-left: 1px solid;
  border-right: 1px solid;
  background-color: white;
}

.custom-list-item:last-child {
  border-bottom: 1px solid;
}
</style>